<template>
  <div class="main-panel">
    <div class="content-wrapper">
      <div class="row">
        <div class="col-lg-9 col-xs-12 mx-auto">
          <div class="card">
            <div class="card-body border-bottom">
              <h4>Create a new invoice</h4>
            </div>
            <div class="card-body">
              <form-wizard
                @on-complete="setProformaInvoice"
                color="#2154cf"
                shape="tab"
                :title="formTitle"
                :subtitle="formSubtitle"
              >
                <tab-content title="Invoice Items" icon="mdi mdi-account-multiple">
                  <div
                    class="card mb-2"
                    v-for="(item, index) in newInvoice.items"
                    :key="'item'+index"
                  >
                    <div class="card-body pb-0">
                      <div
                        class="w-100"
                        style="position: relative"
                        v-if="newInvoice.items.length > 1"
                      >
                        <div
                          class="item-remove"
                          title="Remove this item"
                          @click="removeItem(index)"
                        >
                          <i class="mdi mdi-window-close"></i>
                        </div>
                      </div>
                      <div class="form-group">
                        <input
                          type="text"
                          v-model="newInvoice.items[index].description"
                          class="form-control"
                          placeholder="Description"
                        />
                      </div>
                      <div class="form-group row">
                        <div class="col-sm-2">
                          <input
                            type="number"
                            v-model="newInvoice.items[index].qty"
                            class="form-control"
                            @keyup="setTotalPrice(index)"
                            placeholder="Qty"
                          />
                        </div>
                        <div class="col-sm-3">
                          <input
                            type="number"
                            v-model="newInvoice.items[index].unit_price"
                            class="form-control"
                            @keyup="setTotalPrice(index)"
                            placeholder="Rate"
                          />
                        </div>
                        <div class="col-sm-3">
                          <select
                            class="form-control form-control-lg"
                            v-model="newInvoice.items[index].unit"
                          >
                            <option>Flat Fee</option>
                            <option>Per Hour</option>
                            <option>Per Day</option>
                            <option>Per Week</option>
                            <option>Per Month</option>
                            <option>Per Year</option>
                            <option>Per Word</option>
                            <option>Per Item</option>
                            <option>Per Unit</option>
                          </select>
                        </div>
                        <div class="col-sm-4 text-right py-3">
                          <span>USD {{ addComma(newInvoice.items[index].total_price) || '0.00' }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div>
                    <button
                      type="button"
                      class="btn btn-outline-primary btn-sm btn-icon-text"
                      @click="addItem"
                    >
                      <i class="mdi mdi-plus btn-icon-prepend"></i>
                      Add new item
                    </button>
                  </div>
                  <div class="clearfix"></div>
                </tab-content>
                <tab-content
                  title="Client"
                  :before-change="validateClient"
                  icon="mdi mdi-account-multiple"
                >
                  <template>
                    <div class>
                      <h4>Client Info</h4>
                      <form class data-vv-scope="form1">
                        <div class="form-group row">
                          <label class="col-sm-3 mt-2">
                            Client name
                            <span class="text-danger">*</span>
                          </label>
                          <div class="col-sm-5">
                            <div class="my-dropdown" tabindex="0">
                              <div id="clientDropdown" class="my-dropdown-content show">
                                <input
                                  v-validate="'required'"
                                  name="Client name"
                                  :class="{'is-invalid':  errors.has('form1.Client name')}"
                                  v-model="newInvoice.client_name"
                                  @focus="clientSearching=true"
                                  @keyup="newInvoice.client_id = null; filterProducts('clientInput', 'clientDropdown')"
                                  class="form-control form-control-sm"
                                  placeholder="Full name"
                                  id="clientInput"
                                />
                                <div class="search-result" v-if="clientSearching">
                                  <a
                                    href="javascript:void(0)"
                                    @click.prevent="selectClient(client);clientSearching=false"
                                    v-for="(client, index) in clients"
                                    :key="'client'+index"
                                  >
                                    {{ client.client_name }}
                                    <br />
                                    <span class="text-mutted">{{ client.client_phone }}</span>
                                  </a>
                                </div>
                              </div>
                            </div>
                            <span class="text-danger">{{ errors.first('form1.Client name') }}</span>
                          </div>
                        </div>
                        <div class="form-group row mt-4">
                          <label class="col-sm-3 mt-2">
                            Address
                            <span class="text-danger">*</span>
                          </label>
                          <div class="col-sm-5">
                            <input
                              type="text"
                              v-validate="'required'"
                              name="Address"
                              :class="{'is-invalid':  errors.has('form1.Address')}"
                              v-model="newInvoice.client_address"
                              class="form-control form-control-sm"
                              placeholder="Address"
                            />
                            <span class="text-danger">{{ errors.first('form1.Address') }}</span>
                          </div>
                        </div>
                        <div class="form-group row">
                          <label class="col-sm-3 mt-2">Email</label>
                          <div class="col-sm-5">
                            <input
                              type="email"
                              v-validate="'email'"
                              data-vv-as="email"
                              name="Email"
                              :class="{'is-invalid':  errors.has('form1.Email')}"
                              v-model="newInvoice.client_email"
                              class="form-control form-control-sm"
                              placeholder="Email address"
                            />
                            <span class="text-danger">{{ errors.first('form1.Email') }}</span>
                          </div>
                        </div>
                        <div class="form-group row">
                          <label class="col-sm-3 mt-2">TIN Number</label>
                          <div class="col-sm-5">
                            <input
                              type="text"
                              v-validate="'numeric|digits:9'"
                              name="TIN Number"
                              :class="{'is-invalid':  errors.has('form1.TIN Number')}"
                              v-model="newInvoice.client_tin"
                              class="form-control form-control-sm"
                              placeholder="Client's TIN Number"
                            />
                            <span class="text-danger">{{ errors.first('form1.TIN Number') }}</span>
                          </div>
                        </div>
                        <div class="form-group row">
                          <label class="col-sm-3 mt-2">PO Box</label>
                          <div class="col-sm-5">
                            <input
                              type="text"
                              v-model="newInvoice.client_pbox"
                              class="form-control form-control-sm"
                              placeholder="PO Box"
                            />
                          </div>
                        </div>
                        <div class="form-group row">
                          <label class="col-sm-3 mt-2">
                            Telephone
                            <span class="text-danger">*</span>
                          </label>
                          <div class="col-sm-5">
                            <vue-tel-input
                              v-model="newInvoice.client_phone"
                              :inputClasses="'form-control'"
                              :placeholder="'Client Phone number'"
                              :defaultCountry="'Rwanda'"
                              :validCharactersOnly="true"
                            />
                          </div>
                        </div>
                        <h5 class="mt-4">Contact person</h5>
                        <hr />
                        <div class="form-group row">
                          <label class="col-sm-3 mt-2">Full name</label>
                          <div class="col-sm-5">
                            <input
                              type="text"
                              name="Contact person name"
                              :class="{'is-invalid':  errors.has('form1.Contact person name')}"
                              v-model="newInvoice.contact_name"
                              class="form-control form-control-sm"
                              placeholder="Ex: Patrick Bagina"
                            />
                            <span
                              class="text-danger"
                            >{{ errors.first('form1.Contact person name') }}</span>
                          </div>
                        </div>
                        <div class="form-group row">
                          <label class="col-sm-3 mt-2">Position</label>
                          <div class="col-sm-5">
                            <input
                              type="text"
                              name="Contact person position"
                              v-model="newInvoice.contact_position"
                              :class="{'is-invalid':  errors.has('form1.Contact person position')}"
                              class="form-control form-control-sm"
                              placeholder="Ex: Managing Director"
                            />
                            <span
                              class="text-danger"
                            >{{ errors.first('form1.Contact person position') }}</span>
                          </div>
                        </div>
                        <div class="form-group row">
                          <label class="col-sm-3 mt-2">Telephone</label>
                          <div class="col-sm-5">
                            <vue-tel-input
                              v-model="newInvoice.contact_phone"
                              :inputClasses="'form-control'"
                              :placeholder="'Contact mobile number'"
                              :defaultCountry="'Rwanda'"
                              :validCharactersOnly="true"
                            />
                          </div>
                        </div>
                        <div class="form-group row">
                          <label class="col-sm-3 mt-2">Contact person Email</label>
                          <div class="col-sm-5">
                            <input
                              type="email"
                              v-validate="'email'"
                              data-vv-as="email"
                              name="Contact person Email"
                              :class="{'is-invalid':  errors.has('Contact person Email')}"
                              v-model="newInvoice.contact_email"
                              class="form-control form-control-sm"
                              placeholder="Contact person Email"
                            />
                            <span class="text-danger">{{ errors.first('Contact person Email') }}</span>
                          </div>
                        </div>
                      </form>
                    </div>
                  </template>
                </tab-content>
                <tab-content title="Review" icon="mdi mdi-account-multiple">
                  <div class="pl-3">
                    <div class="container-fluid">
                      <div class="row">
                        <div class="col-lg-5">
                          <!-- <img src="<?=base_url('assets/logo.png')?>" class="img img-fluid w-100" alt="logo"> -->
                        </div>
                        <div class="col-lg-7">
                          <h3 class="text-right my-5">Proforma Invoice&nbsp;&nbsp;#INV-17</h3>
                        </div>
                      </div>
                      <hr />
                    </div>
                    <div class="container-fluid d-flex justify-content-between">
                      <div class="col-lg-5 pl-0">
                        <h4 class="mt-4 mb-2">
                          <b>{{ newInvoice.client_name }}</b>
                        </h4>
                        <h4>{{ newInvoice.client_address }}</h4>
                        <h4>{{ newInvoice.client_phone }}</h4>
                        <h4>{{ newInvoice.client_email }}</h4>
                      </div>
                      <div class="col-lg-4 pr-0">
                        <p class="mt-4 mb-2">
                          <b>Amount due</b>
                        </p>
                        <h2>USD {{ addComma(newInvoice.discounted) }}</h2>
                      </div>
                    </div>
                    <div class="container-fluid d-flex justify-content-between">
                      <div class="col-lg-3 pl-0">
                        <h5
                          class="mb-0 mt-5"
                        >Invoice Date : {{ dukaHotelDate(new Date().toISOString().slice(0, 10)) }}</h5>
                      </div>
                    </div>

                    <div class="container-fluid mt-5 d-flex justify-content-center w-100">
                      <div class="table-responsive w-100">
                        <table class="table table-striped">
                          <thead>
                            <tr class>
                              <th>#</th>
                              <th>Description</th>
                              <th class="text-right">Qty</th>
                              <th class="text-right">Unit price</th>
                              <th class="text-right">Total Amount</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr
                              class="text-right"
                              v-for="(dropin, i) in newInvoice.items"
                              :key="'dropin'+i"
                            >
                              <td class="text-left">{{ incrementIndex(i) }}</td>
                              <td class="text-left">{{ dropin.description }}</td>
                              <td class="text-right">{{ dropin.qty }}</td>
                              <td>USD {{ addComma(dropin.unit_price) }}</td>
                              <td>USD {{ addComma(dropin.total_price) }}</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                    <div class="container-fluid mt-5 w-100">
                      <p class="text-right mb-2">
                        <b>Total amount:</b>
                        USD {{ addComma(dropInsTotal()) }}
                      </p>
                      <p class="text-right mb-2">
                        <b>Total Discount:</b>
                        USD {{ addComma(newInvoice.amount) }} ( {{ newInvoice.discount }}% )
                      </p>
                      <p class="text-right mb-2" v-if="Number(newInvoice.discount)">
                        <b>Discounted amount:</b>
                        USD {{ addComma(newInvoice.discounted) }}
                      </p>
                    </div>
                  </div>
                  <div class="clearfix"></div>
                </tab-content>
                <!-- <tab-content title="Send" icon="mdi mdi-account-multiple"></tab-content> -->
              </form-wizard>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { VueTelInput } from "vue-tel-input";
export default {
  name: "ScratchInvoice",
  components: {
    "vue-tel-input": VueTelInput
  },
  data: () => ({
    newInvoice: {
      client_id: null,
      client_name: null,
      client_address: null,
      client_phone: null,
      client_email: null,
      client_pbox: null,
      client_tin: null,
      contact_name: null,
      contact_position: null,
      contact_phone: null,
      contact_email: null,
      payment_method: null,
      payment_date: null,
      comment: null,
      shipping_fee: 0,
      other_charges: 0,
      discount: 0,
      amount: 0,
      amount_paid: 0,
      amount_remain: 0,
      discounted: null,
      delivery_date: null,
      delivery_period: null,
      items: []
    },
    clientSearching: false,
    totalAmount: 0,
    clients: []
  }),
  created() {
    this.addItem();
  },
  methods: {
    addItem() {
      this.newInvoice.items.push({
        qty: 1,
        unit_price: 0,
        total_price: 0,
        description: null,
        unit: "Flat Fee"
      });
    },
    removeItem(key) {
      this.newInvoice.items.splice(key, 1);
    },
    onComplete() {
      console.log("helllo!", this);
    },
    setTotalPrice(key) {
      this.newInvoice.items[key].total_price =
        Number(this.newInvoice.items[key].qty) *
        this.newInvoice.items[key].unit_price;
    },
    selectClient(client) {
      this.newInvoice.client_id = client.id;
      this.newInvoice.client_name = client.client_name;
      this.newInvoice.client_address = client.client_address;
      this.newInvoice.client_phone = client.client_phone;
      this.newInvoice.client_email = client.client_email;
      this.newInvoice.client_pbox = client.client_pbox;
      this.newInvoice.contact_name = client.contact_name;
      this.newInvoice.contact_position = client.contact_position;
      this.newInvoice.contact_phone = client.contact_phone;
      this.newInvoice.contact_email = client.contact_email;
      this.newInvoice.discount = client.client_discount;
    },
    dropInsTotal() {
      var result = 0;
      const dropIns = this.newInvoice.items;
      for (let item in dropIns) {
        result = result + Number(item.total_price);
      }
      this.totalAmount = result;
      return result;
    },
    setProformaInvoice() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.dropInsTotal();
          this.newInvoice.total_amount = this.totalAmount;
          var formData = this.formData(this.newInvoice);
          let url = "customer/set-proforma-invoice";
          let DispatchpParams = { formData: formData, url: url };
          this.$store
            .dispatch("dukaPostRequest", DispatchpParams)
            .then(response => {
              console.log(response.data);
            });
        }
      });
    },
    validateClient() {
      return new Promise((resolve, reject) => {
        this.$validator.validateAll("form1").then(valid => {
          if (valid) resolve(true);
          else reject("Client not validated");
        });
      });
    }
  }
};
</script>
<style lang="css">
.item-remove {
  cursor: pointer;
  height: 20px;
  position: absolute;
  right: -27px;
  top: -25px;
  width: 20px;
  background-repeat: no-repeat;
  border-width: 0px !important;
  border-style: initial !important;
  border-color: initial !important;
  background: #ef5958;
  border-radius: 50px;
  padding-left: 3px;
  color: #fff;
  font-weight: bold;
}
</style>